import { fetch } from 'http-common';

class UsersDataService {
  private http = fetch();

  private ep = '/v1/users';

  public async getCurrentUser() {
    return this.http.get(`${this.ep}/me`);
  }

  public async getZones() {
    return this.http.get(`${this.ep}/zones`);
  }

  public async getCurrentUserZones(hasSpecialZones: boolean) {
    return this.http.get(`${this.ep}/zones/myZones`, {
      params: { withspecialzone: hasSpecialZones },
    });
  }

  public async getLatestSeason() {
    return this.http.get(`${this.ep}/seasons/newest`);
  }
}

const usersDataService = new UsersDataService();

export { usersDataService };
